import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrLatticeIcon = React.memo<IconProps>(({
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M23 5.30944e-06H8.99998C8.57998 5.30944e-06 8.19998 0.260005 8.05998 0.660005L0.0599841 22.66C-0.190016 23.29 0.329984 24.02 0.999984 24H15C15.42 24 15.8 23.74 15.94 23.34L23.94 1.34001C24.19 0.710005 23.67 -0.0199947 23 5.30944e-06ZM9.69998 2.00001H14.57L12.63 7.33001H7.75998L9.69998 2.00001ZM9.96998 14.67H5.09998L7.03998 9.34001H11.91L9.96998 14.67ZM14.03 9.33001H18.9L16.96 14.66H12.09L14.03 9.33001ZM4.36998 16.67H9.23998L7.29998 22H2.42998L4.36998 16.67ZM14.3 22H9.42998L11.37 16.67H16.24L14.3 22ZM19.63 7.33001H14.76L16.7 2.00001H21.57L19.63 7.33001Z" fill={color}/>
  </BaseIcon>
));

AttrLatticeIcon.displayName = 'AttrLatticeIcon';
